/** Set to `true` to show resume buttons in the navbar and footer. */
export const RESUME_ENABLED = false;

export const RESUME_PDF_PATH = "/files/JONES SOLANO RESUME.pdf";
export const RESUME_PDF_TITLE = "Mark Jones Solano — Resume";
